import { isObject } from 'lodash';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAction, setDataAction } from '../../../pages/ChartEditorPage/actions/chartEditor';
import TextWidget from '../../widgets/TextWidget';

export default function TextSection(props) {
  const dispatch = useDispatch();
  const dataTextValue = useSelector((state) => state.chartEditorPage.dataTextValue);

  useEffect(() => {
    dispatch(
      setAction({
        dataTextValue: {
          ...dataTextValue,
          text: props.aggregatedOptions?.data?.text || ''
        }
      })
    );
  }, []);

  const onChange = (e) => {
    dispatch(
      setAction({
        dataTextValue: {
          ...dataTextValue,
          text: e.val
        }
      })
    );
  };

  const onBlur = () => {
    dispatch(setDataAction({ dataType: 'text' }));
  };

  const text = isObject(dataTextValue) ? dataTextValue.text : dataTextValue;

  return (
    <TextWidget value={text} className="h-full" placeholder="Paste text here" onBlur={onBlur} onChange={onChange} />
  );
}
